// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__LOthh","createdSearch":"index_createdSearch__FDhF+","custom_table":"index_custom_table__Le-8n"};